import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { IMAGES } from "@/data/site";

const Ctx = createContext({ overrides: {}, refresh: () => {} });

export function ContentProvider({ children }) {
  const [overrides, setOverrides] = useState({});
  const refresh = () => api.get("/content").then((r) => setOverrides(r.data || {})).catch(() => {});
  useEffect(() => { refresh(); }, []);
  return <Ctx.Provider value={{ overrides, refresh }}>{children}</Ctx.Provider>;
}

export const useContent = () => useContext(Ctx);

export function useImage(key) {
  const { overrides } = useContent();
  const base = IMAGES[key] || { url: "", alt: key };
  return { url: overrides[`img_${key}`] || base.url, alt: base.alt };
}

export function Img({ k, className = "", eager = false, ...rest }) {
  const { url, alt } = useImage(k);
  return <img src={url} alt={alt} loading={eager ? "eager" : "lazy"} className={className} {...rest} />;
}
